import { render, staticRenderFns } from "./ProjectContextModalEmpty.vue?vue&type=template&id=4f9c6a70&"
import script from "./ProjectContextModalEmpty.vue?vue&type=script&lang=js&"
export * from "./ProjectContextModalEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports